<template>
    <div class="about__direction">
        <a class="reviews__top-btn btn btn--low" href="/exchange/show/" target="_blank">Информация о последнем загруженном файле</a>
        <br/>
        <div class="reviews__top-btn btn btn--low" @click="update">Обновить каталог</div>
        <div class="loader" :class="{ active: preloader }"><span></span><span></span><span></span></div>
    </div>
</template>

<script>
import errors from "@/components/mixins/errors";
export default {
    name: "ExchangeBtns",
    mixins : [errors],
    data() {
        return {
            preloader: false
        }
    },
    methods: {
        update() {
            this.preloader = true;
            fetch("/api/exchange/catalog/update/", {method: 'GET'})
                .then(response => response.json())
                .then(async resp => {
                    if (resp.success !== true) {
                        window.toast.error(resp.message);
                        this.preloader = false;
                    } else {
                        window.toast.success('Обмен', 'Каталог успешно обновлен!');
                        this.preloader = false;
                    }
                });

        }
    }
}
</script>

<style scoped>

</style>